import validate from "/codebuild/output/src3507326296/src/luckywise/node_modules/.pnpm/nuxt@3.17.0_@parcel+watcher@2.5.1_@types+node@24.9.1_db0@0.3.4_eslint@9.38.0_jiti@2.6.1__iore_x6m2e4getqzqxazeuv2lo7fgai/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45age_45verification_45global from "/codebuild/output/src3507326296/src/luckywise/middleware/01.age-verification.global.ts";
import _02_45auth_45global from "/codebuild/output/src3507326296/src/luckywise/middleware/02.auth.global.ts";
import manifest_45route_45rule from "/codebuild/output/src3507326296/src/luckywise/node_modules/.pnpm/nuxt@3.17.0_@parcel+watcher@2.5.1_@types+node@24.9.1_db0@0.3.4_eslint@9.38.0_jiti@2.6.1__iore_x6m2e4getqzqxazeuv2lo7fgai/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45age_45verification_45global,
  _02_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  result: () => import("/codebuild/output/src3507326296/src/luckywise/middleware/result.ts"),
  scan: () => import("/codebuild/output/src3507326296/src/luckywise/middleware/scan.ts")
}